var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"before-close":_vm.handleClose,"width":"300px"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"tip-div"},[_vm._v(" 正在生成中 ")]),(_vm.qrCode)?_c('img',{staticClass:"img",attrs:{"src":_vm.qrCode}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }